import React from "react";
import { cloudEngineeringData } from "../data/software-apps";
import logoImg from "../images/software-and-apps/Cloud-Adoption-Engineering.svg";

const CloudEngineering = () => {
  return (
    <div className="row align-items-center" id="cloud-adoption-and-engineering">
      <div className="col-12 col-lg-6 text-center text-lg-start">
        <img
          src={logoImg}
          loading="lazy"
          style={{ width: "8rem", height: "8rem" }}
          alt="Cloud Adoption & Engineering"
          className="software-and-apps-img"
        />
        <h2 className="fs-56 lh-64 gilroy-bold py-5 text-danger">
          Cloud Adoption & Engineering
        </h2>
        <p className="fs-16 text-align-justify">
          With the ever-increasing massive workloads on the Cloud, the long run
          lies in cloud Designing. Complex frameworks from information centers
          got to be migrated to Cloud. The moved applications with Cloud
          Designing Administrations empower them to be re-platformed and
          re-hosted making it Cloud neighborly. In case you're looking to send
          Cloud Designing administrations, you must approach us.
        </p>
      </div>
      <div className="col-12 col-lg-6">
        <div className="row align-items-center">
          <div className="col-12 col-md-6">
            {cloudEngineeringData.slice(0, 3).map((info) => (
              <div
                key={info.title}
                className="text-center digital-card border px-4 py-5 my-4 rounded"
              >
                <img
                  src={info.img}
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6">
            {cloudEngineeringData.slice(3, 5).map((info) => (
              <div
                key={info.title}
                className="text-center digital-card border px-4 py-5 mb-4 rounded"
              >
                <img
                  src={info.img}
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudEngineering;
